module.exports = __webpack_public_path__ + "static/img/15075B_2_R_20200428_LC.ecfd8f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/15075B_2_R_20200428_LC.png
// module id = fyDB
// module chunks = 0